export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};